import { useSelector } from "react-redux";
import { RootState } from "store/reducers";

export type MaintenancePlan = "core" | "plus";

const MAINTENANCE_PLAN_IDS: Record<string, MaintenancePlan> = {
    SCMAMO5: "core",
    SPMAMO5: "plus"
};

// Keyed on plan id until the maintenance roles exist (sc-61068)
export const useMaintenancePlan = (): MaintenancePlan | undefined => {
    const planId = useSelector(
        (s: RootState) => s.user.userInfo?.Plan?.Details?.Id
    );

    return planId ? MAINTENANCE_PLAN_IDS[planId] : undefined;
};
